/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Stack from "../ui/Stack";
import Flex from "../ui/Flex";
import Text from "../ui/Text";
import Title from "../ui/Title";
import Icon from "../ui/Icon";
import Anchor from "../ui/Anchor";
import { useCompany } from "../../lib/react-query/useCompany";

const Wrapper = styled(Stack)`
  padding: 2rem 1rem;
  text-align: center;
`;

const Description = styled(Stack)`
  max-width: 480px;
  margin: 0 auto;
`;

const ContactCard = styled(Stack)`
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background: rgba(${({ theme }) => theme.colors.error.rgb}, 0.08);
`;


const CannotRescheduleEmptyState = ({ reason }) => {
  const { data: company } = useCompany();
  const phone = company?.phone;
  const email = company?.email;

  return (
    <Wrapper as="section" $gap="1.5rem" $align="center">
      <Stack $gap="1rem" $align="center">
        <Icon.CalendarCross color="primary" size={Icon.SIZE.XL} />
        <Stack $gap="0.5rem" $align="center">
          <Title size="h2">This booking can't be rescheduled</Title>
          <Description $align="center" $gap="0">
            <Text>{reason}</Text>
            {(phone || email) && <Text>The venue may be able to help — try reaching out to them</Text>}
          </Description>
        </Stack>
      </Stack>

      {(phone || email) && (
        <ContactCard $gap="0.5rem" $align="center" $justify="center">
          {phone && (
            <Flex $align="center" $gap="0.5rem">
              <Icon.Phone color="dark" />
              <Anchor to={`tel:${phone}`} rel="noopener noreferrer" underline="hover">
                <Text color="dark" size="small">{phone}</Text>
              </Anchor>
            </Flex>
          )}
          {email && (
            <Flex $align="center" $gap="0.5rem">
              <Icon.Email color="dark" />
              <Anchor to={`mailto:${email}`} rel="noopener noreferrer" underline="hover">
                <Text color="dark" size="small">{email}</Text>
              </Anchor>
            </Flex>
          )}
        </ContactCard>
      )}

    </Wrapper>
  );
};

export default CannotRescheduleEmptyState;
